// extracted by mini-css-extract-plugin
export default {"ItemAddForm":"ItemAddForm_ItemAddForm__oAUb+"};